<template>
  <nav class="main_nav w-100p d-flex flex-cnt al-cnt font-mont" id="main-nav" ref="main_nav">
    <div class="nav_inner w-100p d-flex flex-sb al-cnt">
      <div class="d-flex al-cnt">
        <a href="/">
          <img src="@/assets/img/Logo-b.svg" style="max-width: 160px;">
        </a>

        <div class="d-flex al-cnt nav_menus pc_nav">
          <!--
          <router-link to="service"><h4>SERVICE</h4></router-link>
          <router-link to="plans"><h4>사용안내</h4></router-link>
          <router-link to="notice"><h4>NOTICE</h4></router-link>
          <router-link to="help"><h4>HELP</h4></router-link>
          -->

          <a href="/service"><h4>SERVICE</h4></a>
          <a href="/plans"><h4>사용안내</h4></a>
          <a href="/notice"><h4>NOTICE</h4></a>
          <a href="/help"><h4>HELP</h4></a>
        </div>
      </div>

      <div class="pc_nav">
        <div class="d-flex al-cnt" v-if="loginCheck===false">
          <a href="/login">Sign In</a>
          <i class="xi-minus-thin xi-rotate-90 mag-l-025 mag-r-025"></i>
          <a href="">CONTACT US</a>
        </div>

        <div class="d-flex al-cnt" v-if="loginCheck===true">
          <router-link to="/company" v-if="myInfo.mlevel >= 10">
            <a href="javascript:void(0)"> 관리자 </a>
            <i class="xi-minus-thin xi-rotate-90 mag-l-025 mag-r-025"></i>
          </router-link>
          <router-link to="/member" v-if="myInfo.mlevel === 5">
            <a href="javascript:void(0)"> 담당자 </a>
            <i class="xi-minus-thin xi-rotate-90 mag-l-025 mag-r-025"></i>
          </router-link>
          <router-link to="/dashboard" v-if="myInfo.mlevel === 1">
            <a href="javascript:void(0)"> 대시보드 </a>
            <i class="xi-minus-thin xi-rotate-90 mag-l-025 mag-r-025"></i>
          </router-link>
          <a href="javascript:void(0)" @click="signOut">SIGN OUT</a>
        </div>
      </div>

      <div class="mo_nav">
        <input type="checkbox" id="monav"/>
        <label for="monav">
          <i class="xi-bars xi-2x"></i>
          <i class="xi-close xi-2x"></i>
        </label>
        <div class="mo_nav_menu">
          <a href="/service"><h4>SERVICE</h4></a>
          <a href="/plans" class="font-noto"><h4>사용안내</h4></a>
          <a href="/notice"><h4>NOTICE</h4></a>
          <a href="/help"><h4>HELP</h4></a>
          <div class="d-flex pad-l-2 al-cnt" v-if="loginCheck===false">
            <a href="/login">Sign In</a>
            <a href="">CONTACT US</a>
          </div>
          <div class="d-flex al-cnt pl-8" v-if="loginCheck===true">
            <router-link to="/company" v-if="myInfo.mlevel >= 10">
              관리자
            </router-link>
            <router-link to="/member" v-if="myInfo.mlevel == 5">
              담당자
            </router-link>
            <i class="xi-minus-thin xi-rotate-90 mag-l-025 mag-r-025"></i>
            <a href="javascript:void(0)" @click="signOut">SIGN OUT</a>
          </div>
        </div>
      </div>
    </div>
  </nav>

</template>

<script>
// import "@/assets/js/home.nav.js"
import store from "@/store"

export default {
  data () {
    return {
      loginCheck: false,
      username: "",
      password: "",
      myInfo: {},
      platform: ""
    }
  },
  methods: {
    signOut(){
      localStorage.removeItem('authorization');
      this.$router.push('/');
      this.loginCheck = false;
    },
    /*getMyInfo(){
      console.log("getMyInfo");
      const me = this;
      // const url = '/py_api/api/v1/member/me/';
      const idx = store.state.account.id;
      console.log(`idx: ${idx}`);
      const url = `/new_api/member/${idx}`;
      // const url = `/new_api/member/me`;
      this.axios.get(url).then((res) => {
        console.log(res);
        if(res.status === 200){
          if( res.data.err_code === 0 ){
            me.myInfo = res.data.contents;
            console.log(me.myInfo);
          }
        }
        else{
          alert("변경 중 오류가 발생하였습니다. 잠시 후 다시 시도해주세요.");
        }
      }).catch((err)=>{
        console.log(err);
      });
    },*/

    getAgentSystem(){
      if(!("navigator" in window)){
        return "unknown";
      }

      // Use the modern 'web hints' provied by
      // 'userAgentData' if available, else use
      // the deprecated 'platform' as fallback.
      this.platform = (navigator.userAgentData?.platform || navigator.platform)?.toLowerCase();

      /*if(platform.startsWith("win")) return "windows";
      if(platform.startsWith("mac")) return "macos";
      if(platform.startsWith("linux")) return "linux";
      return "unknown";*/
    },

    scrollEvent(){
      let nav = this.$refs.main_nav;
      if (document.documentElement.scrollTop >= 50 ) {
        // nav.classList.add('hide');
        nav.classList.add('bg-active');
      }
      else {
        // nav.classList.remove('hide');
        nav.classList.remove('bg-active');
      }
    }
  },
  mounted() {
    const login_token = localStorage.getItem('authorization');
    if( login_token === null || login_token === "" ){

      /*
      * ios 메소드 호출
      * var message = {
            'action': 'location',
            'name': 'returnLocation'
        };
        window.webkit.messageHandlers.atti.postMessage(message);
      *
      * android 메소드 호출
      * var a_info = window.atti.getUserInfo();
        const obj = JSON.parse(a_info);
      * */
      //


      // 토큰이 없을때
      //this.signOut();
      var message = {
            'action': 'location',
            'name': 'returnLocation'
        };
      window.webkit.messageHandlers.atti.postMessage(message);
    }
    else {
      this.loginCheck = true;
      this.myInfo = store.state.myInfo;
      if( this.myInfo.idxMember <= 0 ){
        this.signOut();
      }
      // this.getMyInfo();
    }

    this.getAgentSystem();

    document.addEventListener('scroll', this.scrollEvent);
  }
}
</script>

<style scoped>
.cw {
  color: #FFF;
}
</style>
